import { createAction, props } from '@ngrx/store';
import { NotifyModel } from 'app/models/notify.model';

export const notifySuccess = createAction(
  '[Notify] Success',
  props<{ notification: NotifyModel }>()
);

export const notifyError = createAction(
  '[Notify] Error',
  props<{ notification: NotifyModel }>()
);
